/**
 * Directions to a spot in the phone's own maps app (bugs.md: the app as a spot-finder, for anyone who can
 * see the spot, Anonymous included). Apple Maps on an iPhone, iPad or Mac; Google Maps everywhere else.
 * A spot is a public place pinned exactly, so its point is no secret.
 */
export function directionsUrl(lat: number, lng: number, name: string): string {
  const apple = /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent)
  return apple
    ? `https://maps.apple.com/?daddr=${lat},${lng}&q=${encodeURIComponent(name)}`
    : `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
}
